<template>
  <v-avatar
    :color="color"
    :style="randomColor"
    :size="size"
    :tile="tile"
  >
    <span
      v-if="showText"
      :style="spanStyle"
      class="white--text"
    >
      {{ letter }}
    </span>
    <img
      :style="imgStyle"
      :src="photoURL"
      :alt="letter"
      @load="imageLoaded"
      @error="errorLoading"
    >
  </v-avatar>
</template>
<script>
import { randomMaterialColor } from '@/utils';

export default {
  name: 'Avatar',
  props: {
    color: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 48
    },
    tile: {
      type: Boolean,
      default: false
    },
    /** Storage ref */
    src: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      showText: true,
      photoURL: ''
    };
  },
  computed: {
    letter() {
      if (!this.text) return '';

      return this.text[0].toUpperCase();
    },

    imgStyle() {
      return {
        display: this.showText ? 'none' : 'block'
      };
    },

    spanStyle() {
      return {
        display: this.showText ? 'block' : 'none',
        fontSize: `${Math.floor((this.size / 48) * 20)}px`,
        fontWeight: '500'
      };
    },

    randomColor() {
      const rc = randomMaterialColor();
      return { backgroundColor: rc, borderColor: rc };
    }
  },
  watch: {
    src: {
      handler(val) {
        if (!val) return;
        this.photoURL = val;
      },
      immediate: true
    }
  },
  methods: {
    imageLoaded() {
      this.showText = false;
    },
    errorLoading() {
      this.showText = true;
    }
  }
};
</script>
<style scoped>
img {
  object-fit: cover;
}
</style>
